module.exports = __webpack_public_path__ + "img/trophy-icon.df3284ab.svg";